"use client"
/* */
const locales = {"de-DE": {  "label.optional": `(optional)`,
},"en-US": {  "label.optional": `(optional)`,
}};

export { locales as default };
//# sourceMappingURL=_.locale.json@3b9d9e153ad753f427f375d1275fbcad.mjs.map
